<template>
    <div>
        <app-nav-bar />
        <app-main-menu />
        <div class="content-wrapper">
            <app-bread-crumbs  />
            <router-view />
        </div>
        <app-footer />
        <control-side-bar />
    </div>
</template>

<script lang="ts">

    import { defineComponent } from "vue";
    import AppNavBar from '../components/partials/AppNavBar.vue'
    import AppMainMenu from '../components/partials/AppMainMenu.vue'
    import AppBreadCrumbs from '../components/partials/AppBreadCrumbs.vue'
    import AppFooter from '../components/partials/AppFooter.vue'
    import ControlSideBar from '../components/partials/ControlSideBar.vue'
    
    export default defineComponent({
        components: {
            AppNavBar, AppMainMenu, AppBreadCrumbs, AppFooter, ControlSideBar
        },
    });
</script>



